import type ImageType from "@travily/types/shared/Image";
import { Rating } from "@ui/components/Rating";
import { tv } from "@ui/lib/tv";
import { AccountAvatar } from "@/components/AccountAvatar/AccountAvatar";

const reviewCard = tv({
  slots: {
    root: "flex flex-col gap-4 overflow-hidden rounded-3xl bg-yellow-50 p-4 shadow-[inset_0px_-1px_0px_0px_#e2d5b5,inset_0px_0px_0px_1px_#eee2c4]",
    header: "flex items-center gap-2 lg:gap-3",
    info: "flex flex-col",
    name: "text-lg font-extrabold leading-6 text-yellow-950 lg:text-2xl lg:leading-8 lg:tracking-[-0.24px]",
    body: "text-sm leading-5 text-yellow-800 lg:text-lg lg:leading-6",
  },
});

/** Displays a single product review with author avatar, star rating, and review text. */
export interface ReviewCardProps {
  /** Review author with account type, avatar, initial, and display name. */
  author: {
    profile_type: string;
    avatar?: ImageType | null;
    initial: string;
    name: string;
  };
  /** Review text content. */
  body: string;
  /** Star rating from 1 to 5. */
  rating: number;
}

export function ReviewCard({ author, body, rating }: ReviewCardProps) {
  const styles = reviewCard();

  return (
    <div className={styles.root()}>
      <div className={styles.header()}>
        <AccountAvatar account={author} className="lg:hidden" shape="square" size="40" />
        <AccountAvatar account={author} className="hidden lg:flex" shape="square" size="52" />
        <div className={styles.info()}>
          <span className={styles.name()}>{author.name}</span>
          <Rating score={rating} size="20" variant="full" />
        </div>
      </div>
      <p className={styles.body()}>{body}</p>
    </div>
  );
}
